import styled from "styled-components";

export const GifsWrapper = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 16px;
  place-content: space-around;
`;
